if (!customElements.get('product-info')) {
  // Tap toggle for the alert link info tooltips (hover and keyboard focus are handled in CSS).
  const closeAlertInfoTooltips = (except) => {
    document.querySelectorAll('.wk-alert-info.is-open').forEach((info) => {
      if (info !== except) info.classList.remove('is-open');
    });
  };
  document.addEventListener('click', (event) => {
    const info = event.target.closest('.wk-alert-info__button')?.parentElement;
    closeAlertInfoTooltips(info);
    info?.classList.toggle('is-open');
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeAlertInfoTooltips();
    if (document.activeElement?.closest('.wk-alert-info')) document.activeElement.blur();
  });

  const readLastSoldListingPrice = () => {
    const placeholder = document.getElementById("lastSoldListing");
    if (!placeholder) return "";

    const rawPrice = placeholder.dataset.lastSoldPrice
      || placeholder.textContent.replace(/Last Sold Listing:/i, '').trim();
    const parsedPrice = parseFloat(String(rawPrice).replace(/[^0-9.]/g, ''));
    placeholder.remove();

    return Number.isNaN(parsedPrice) ? "" : '$' + parsedPrice.toFixed(2);
  };

  const normalizeSellerName = (name) =>
    String(name || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  const parseListingPrice = (price) => {
    const parsed = parseFloat(String(price || '').replace(/[^0-9.]/g, ''));
    return Number.isNaN(parsed) ? null : parsed;
  };

  const normalizeMarketplaceTitle = (title) =>
    String(title || '')
      .replace(/<\/?[a-zA-Z][^>]*>/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/[\[\]()[\]{}]/g, ' ')
      .replace(/["']/g, '')
      .replace(/[^a-zA-Z0-9&]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  const marketplaceTitlesMatch = (cardTitle, productTitle) => {
    const normalizedCardTitle = normalizeMarketplaceTitle(cardTitle);
    const normalizedProductTitle = normalizeMarketplaceTitle(productTitle);
    return normalizedCardTitle && normalizedProductTitle && normalizedCardTitle === normalizedProductTitle;
  };

  const getCardProductTags = (card) =>
    card?.closest?.('[data-product-tags]')?.dataset?.productTags || '';

  // Lot members/aggregates must not appear as individual seller rows on the global PDP.
  const isLotSellerListingCard = (card) => {
    const tags = getCardProductTags(card);
    return tags.includes('__lot_member') || tags.includes('__lot_aggregate');
  };

  const getLotSlugFromTags = (tags) => {
    const slugTag = String(tags || '')
      .split(',')
      .map((tag) => tag.trim())
      .find((tag) => tag.startsWith('__lot:') && tag !== '__lot_aggregate');
    return slugTag ? slugTag.slice('__lot:'.length) : '';
  };

  const lotProductTags = (product) =>
    String(product?.tags || '')
      .split(',')
      .map((tag) => tag.trim())
      .filter(Boolean);

  const findLotAggregateHandleBySlug = async (lotSlug) => {
    if (!lotSlug) return '';
    try {
      const response = await fetch(`/collections/lots/products.json?limit=250`);
      if (!response.ok) return '';
      const data = await response.json();
      const match = (data.products || []).find((product) => {
        const tags = lotProductTags(product);
        return tags.includes('__lot_aggregate') && tags.includes(`__lot:${lotSlug}`);
      });
      return match?.handle || '';
    } catch (_error) {
      return '';
    }
  };

  const findLotAggregateUrl = (sellerProductCards, lotSlug) => {
    if (!lotSlug) return '/collections/lots';
    if (sellerProductCards) {
      const cards = [...sellerProductCards.getElementsByClassName('card__information')];
      for (const card of cards) {
        const tags = getCardProductTags(card);
        if (!tags.includes('__lot_aggregate')) continue;
        if (!tags.includes(`__lot:${lotSlug}`)) continue;
        const href = card.querySelector('a[href*="/products/"]')?.getAttribute('href');
        if (href) return href;
      }
    }
    return '/collections/lots';
  };

  const resolveLotMemberNoticeLink = async () => {
    const link = document.querySelector('#lot-member-purchase-notice a[data-lot-slug]');
    if (!link) return;
    const lotSlug = link.getAttribute('data-lot-slug');
    const handle = await findLotAggregateHandleBySlug(lotSlug);
    if (handle) link.setAttribute('href', `/products/${handle}`);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resolveLotMemberNoticeLink);
  } else {
    resolveLotMemberNoticeLink();
  }

  const buildLotOnlyAvailabilityHtml = (lotUrl) =>
    `Out of stock (available as part of a <a href="${lotUrl}" style="color: rgb(128, 37, 245);">lot</a>).`;

  const SHIPPING_TRUCK_ICON_SVG =
    '<svg class="wk-seller-card__shipping-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#166534" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H3"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>';

  const sellerNamesMatch = (rowName, dataName) => {
    const a = normalizeSellerName(rowName);
    const b = normalizeSellerName(dataName);
    return a === b || a.includes(b) || b.includes(a);
  };

  const sellerPricesMatch = (rowPrice, dataPrice) => {
    const a = parseListingPrice(rowPrice);
    const b = parseListingPrice(dataPrice);
    return a !== null && b !== null && a === b;
  };

  const buildMarketStatsHtml = ({ average = "N/A", median = "N/A", lastSoldListingPrice = "" } = {}) => {
    const lastSoldStatHtml = lastSoldListingPrice
      ? `<div class="wk-market-stats__stat">
          <div class="wk-market-stats__label">Last Sold Listing</div>
          <div class="wk-market-stats__value" id="lastSoldListingPrice">${lastSoldListingPrice}</div>
        </div>
        <div class="wk-market-stats__divider"></div>`
      : '';

    return `
      <div class="wk-market-stats">
        <div class="wk-market-stats__prices">
          ${lastSoldStatHtml}
          <div class="wk-market-stats__stat">
            <div class="wk-market-stats__label">Average Price</div>
            <div class="wk-market-stats__value" id="averagePrice">${average}</div>
          </div>
          <div class="wk-market-stats__divider"></div>
          <div class="wk-market-stats__stat">
            <div class="wk-market-stats__label">Median Price</div>
            <div class="wk-market-stats__value" id="medianPrice">${median}</div>
          </div>
        </div>
        <div class="wk-market-stats__trust">
          <div class="wk-market-stats__badge">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#6D28D9" stroke-width="2" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>
            <span>Verified<br>Sellers</span>
          </div>
          <div class="wk-market-stats__badge">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#6D28D9" stroke-width="2" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            <span>Secure<br>Checkout</span>
          </div>
          <div class="wk-market-stats__badge">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#6D28D9" stroke-width="2" aria-hidden="true"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            <span>Buyer<br>Protection</span>
          </div>
        </div>
      </div>`;
  };

  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      variantChangeUnsubscriber = undefined; // WARGAME TRADER MODIFICATION

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id'); // WARGAME TRADER MODIFICATION
        this.submitButton = this.querySelector('[type="submit"]'); // WARGAME TRADER MODIFICATION
        this.setVariantData(); // WARGAME TRADER MODIFICATION
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));

        // WARGAME TRADER MODIFICATION: subscribe to variantChange for quantity rule updates on seller marketplace
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          if (this.quantityInput) {
            this.setQuantityBoundries();
          }
        });
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
        this.variantChangeUnsubscriber?.(); // WARGAME TRADER MODIFICATION
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === '.quantity__label') {
              const updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');
              if (updatedAriaLabelledBy) {
                current.setAttribute('aria-labelledby', updatedAriaLabelledBy);
                // Update the referenced visually hidden element
                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      // === WARGAME TRADER SELLER MARKETPLACE START ===

      setVariantData = () => {
        const marketplaceMarker = this.querySelector('.wk_global_product');
        const productTagsData = marketplaceMarker?.dataset.tags || '';
        const isMarketplaceGlobal = productTagsData.includes('wk_global') && !productTagsData.includes('se_global');
        const shouldProcessMarketplaceListings = marketplaceMarker?.dataset.marketplaceProcessing === 'true';
        const loadingSpinner = this.querySelector('.custom-page-fully-loaded-spinner');
        const globalContentLoadingDiv = this.querySelector('.product__info-container');

        // If this is a global product, and not a seller-specific one, hide the default add to cart form as they will be adding to cart from the seller table
        if (isMarketplaceGlobal) {
          if (loadingSpinner && shouldProcessMarketplaceListings) {
            loadingSpinner.parentElement.style.textAlign = 'center';
            loadingSpinner.classList.remove('hidden');
          }
          [
            'forms_fallback_session_id',
            'forms_previous_session_id',
            'forms_visit_count',
            '939827-dismissed-after-submit',
            '939827-dismissed-in-session'
          ].forEach((key) => localStorage.removeItem(key));

          this.waitForElement('shopify-forms-embed').then(() => {
            const alertMeWhenAvailableForm = document.querySelector(`[data-forms-id="forms-root-939827"]`);
            if (alertMeWhenAvailableForm) {
              alertMeWhenAvailableForm.style.display = 'none';
            }
            const alertMeWhenAvailableFormRoot = alertMeWhenAvailableForm?.firstElementChild?.shadowRoot;
            const preRenderedAlertLink = document.getElementById('backInStockAlert') || document.getElementById('removeBackInStockAlert');
            if (alertMeWhenAvailableFormRoot && preRenderedAlertLink) {
              this.bindBackInStockAlertLink(preRenderedAlertLink.id);
            }
          });

          this.querySelectorAll('.product-form').forEach(form => form.remove());
          const quantitySections = new Set();
          this.querySelectorAll('.product-form__quantity, [id^="Quantity-Form-"], quantity-input').forEach((element) => {
            const quantitySection = element.closest('.product-form__quantity, [id^="Quantity-Form-"]') || element.closest('div');
            if (quantitySection) {
              quantitySections.add(quantitySection);
            }
          });
          quantitySections.forEach((section) => section.remove());
          const viewAllSellers = document.getElementById('viewAllSellers');
          if (viewAllSellers) {
            viewAllSellers.remove();
          }
          const productTax = this.querySelector('.product__tax');
          if (productTax) {
            productTax.innerHTML = 'Tax and shipping included. Additional discounts calculated at checkout.';
          }
        } else {
            const alertMeWhenAvailableForm = document.querySelector(`[data-forms-id="forms-root-939827"]`);
            if (alertMeWhenAvailableForm) {
              alertMeWhenAvailableForm.remove();
            }
            const productDescriptionDiv = document.getElementsByClassName('product__description');
            if (productDescriptionDiv && productDescriptionDiv.length > 0) {
                if(productDescriptionDiv[0].innerHTML.includes(" | ")) {
                    productDescriptionDiv[0].innerHTML = productDescriptionDiv[0].innerHTML.replace(/ \| /g, "<br><br>").replace(/\)-- /g, ") -- ");
                }
            }
            const currentVariant = [...document.querySelectorAll('div.select option:checked')].map(variant => variant.value).join(" / ");
            if (currentVariant && currentVariant == "Default Title") {
              document.querySelector('variant-selects[id^="variant-selects-template--"]').style.display = 'none';
            }
            const sellProduct = document.getElementById("sellProduct");
            if (sellProduct) {
              sellProduct.style.display = "block";
            }
            if (loadingSpinner) {
              loadingSpinner.classList.add('hidden');
              loadingSpinner.parentElement.style.textAlign = 'left';
            }
            globalContentLoadingDiv?.classList.remove('hidden');
            return;
        }

        const productDescription = this.querySelector('.product__description')?.innerText?.trim() || "";
        const productTags = this.querySelector('#productTags');
        const productSuffix = this.querySelector('.product-page-title-suffix')?.innerText || "";
        const productTitle =
          marketplaceMarker?.dataset.title ||
          `${this.querySelector('.product__title')?.firstElementChild?.innerText || ''}${productSuffix ? ` ${productSuffix}` : ''}`;

        if (localStorage.getItem('showCartPopup') === 'true') {
          // If something was just added to cart, clear the flag immediately to prevent the popup on subsequent reloads then display the add to cart popup.
          localStorage.removeItem('showCartPopup');
          const openCartNotification = () => {
            const cartNotification = document.querySelector('cart-notification');
            if (typeof cartNotification?.open !== 'function') return false;
            cartNotification.open();
            return true;
          };
          if (!openCartNotification()) {
            customElements.whenDefined('cart-notification').then(openCartNotification).catch(() => {});
          }
        }

        // hide vendor title for Global Products (Wargame Trader)
        const vendorTitle = document.getElementById('vendor');
        if (
          vendorTitle &&
          vendorTitle.innerText.toLowerCase().replace(/\s+/g, '').includes("fromwargametrader")
        ) {
            vendorTitle.remove();
        }

        const cartDataPromise = fetch(window.Shopify.routes.root + 'cart.js').then((response) => response.json());
        const browsingContextPromise = window.getWgtBrowsingContext
          ? window.getWgtBrowsingContext()
          : fetch('/browsing_context_suggestions.json').then((response) => response.json());

        browsingContextPromise
        .then(data => {
          const country = data.detected_values.country.name;
          const getSellerProductDataUrl = `/search?q="${productTitle.replace(/ /g, '+').replace(/<\/?p>/g, "").replace(/<\/?br>/g, "").replace(/&/g, "%26")}"&country=${country}`;
          fetch(getSellerProductDataUrl)
            .then((sellerResponse) => sellerResponse.text())
            .then((sellerResponseText) => {
                const sellerProductCards = new DOMParser().parseFromString(sellerResponseText, 'text/html');
                let available_variants = "";
                let totalCardQuantityDataList = [];

                const variants = document.querySelectorAll(`div.select option`);
                const productDiv = document.getElementsByClassName('wk_global_product');
                let currentVariantId;
                if (productDiv.length > 0) {
                  currentVariantId = productDiv[0].getAttribute('data-var');
                }

                // Get all available variant stock
                let available_variants_array = [];
                let availableCountryForVariants = {};
                let matchedLotMember = false;
                let matchedLotSlug = '';
                const allowedCountries = ["United States", "Canada", "United Kingdom"];
                allowedCountries.forEach((allowedCountry) => {
                  availableCountryForVariants[allowedCountry] = [];
                });

                [...sellerProductCards.getElementsByClassName('card__information')].forEach(card => {
                  const cardTitle = card.parentElement.parentElement.parentElement.id;
                  const cardTags = getCardProductTags(card);
                  if (isLotSellerListingCard(card)) {
                    if (
                      marketplaceTitlesMatch(cardTitle, productTitle) &&
                      cardTags.includes('__lot_member')
                    ) {
                      matchedLotMember = true;
                      if (!matchedLotSlug) {
                        matchedLotSlug = getLotSlugFromTags(cardTags);
                      }
                    }
                    return;
                  }
                  const firstAvaliableVariant = card.id;
                  const cardQuantity = card.parentElement.id;

                  if (marketplaceTitlesMatch(cardTitle, productTitle)) {
                    let cardQuantityDataList = cardQuantity.split("+++");
                    cardQuantityDataList = cardQuantityDataList.filter(data => data !== "");
                    [...cardQuantityDataList].forEach(cardQuantityData => {
                        cardQuantityData = cardQuantityData.split("---");
                        if (cardQuantityData.length > 0 && cardQuantityData[4]) {
                          availableCountryForVariants[cardQuantityData[4]].push(cardQuantityData[0]);
                        }
                    });
                    if (!available_variants_array.includes(firstAvaliableVariant) && firstAvaliableVariant !== "") {
                      available_variants_array.push(firstAvaliableVariant);
                    }
                  }
                });
                const lotOnlyAvailabilityUrl = matchedLotMember
                  ? findLotAggregateUrl(sellerProductCards, matchedLotSlug)
                  : '';

                if (available_variants_array.length > 0 && available_variants_array[0].includes("+++")) {
                  available_variants_array = available_variants_array[0].split('+++');
                }

                const productDescriptionDiv = document.getElementsByClassName('product__description');
                if (productDescriptionDiv.length > 0) {
                  if(productDescriptionDiv[0].innerHTML.includes(" | ")) {
                      productDescriptionDiv[0].innerHTML = productDescriptionDiv[0].innerHTML.replace(/ \| /g, "<br><br>").replace(/\)-- /g, ") -- ");
                  }
                }

                if (!allowedCountries.includes(country) || available_variants_array.length === 0 || availableCountryForVariants[country].length === 0) {
                  // If there's no available variants, set each one to unavailable., hide the div, then return
                  available_variants_array[0] = "Not Available";
                  const customerEmail = document.getElementById('customerEmail')?.innerText || '';
                  const existingAlert = document.getElementById('alertExists');
                  const hasExistingAlert = Boolean(existingAlert?.innerText);
                  const alertHref = customerEmail.length > 0 ? '#' : `/customer_authentication/login?return_to=${window.location.pathname}`;
                  const alertLinkId = hasExistingAlert ? 'removeBackInStockAlert' : 'backInStockAlert';
                  const variantSelects = document.querySelector('variant-selects[id^="variant-selects-template--"]');
                  const finalizeNoListingsState = () => {
                    const lastSoldListingPrice = readLastSoldListingPrice();
                    if (lastSoldListingPrice && !document.getElementById("aggregateListingDataDiv")) {
                      const aggregateListingDataDiv = document.createElement('div');
                      aggregateListingDataDiv.id = "aggregateListingDataDiv";
                      aggregateListingDataDiv.classList.add('aggregateListingDataDiv-flex-row');
                      aggregateListingDataDiv.innerHTML = buildMarketStatsHtml({ lastSoldListingPrice });
                      productDiv[0].before(aggregateListingDataDiv);
                    }

                    if (productDiv.length > 0) {
                      productDiv[0].remove();
                    }

                    const sellProduct = document.getElementById("sellProduct");
                    if (sellProduct) {
                      sellProduct.style.display = "block";
                    }
                    if (loadingSpinner) {
                      loadingSpinner.parentElement.style.textAlign = 'left';
                      loadingSpinner.classList.add('hidden');
                    }
                    globalContentLoadingDiv.classList.remove('hidden');
                  };

                  if (variantSelects) {
                    if (lotOnlyAvailabilityUrl) {
                      variantSelects.innerHTML = `<h3>${buildLotOnlyAvailabilityHtml(lotOnlyAvailabilityUrl)}</h3>`;
                    } else {
                      variantSelects.innerHTML = `<div class="wk-stock-alert"><h3 class="wk-stock-alert__title">No listings available</h3><p class="wk-stock-alert__copy">Get an email when a seller lists this item.</p>${existingAlert ? this.getAlertLinkHtml(alertLinkId, alertHref, hasExistingAlert ? 'Remove alert' : 'Notify me', hasExistingAlert ? 'Remove back in stock alert' : 'Alert me when back in stock', 'wk-alert-link--solid') : ''}</div>`;
                    }
                  }

                  if (customerEmail.length > 0 || hasExistingAlert) {
                    this.waitForElement('shopify-forms-embed')
                      .then(() => {
                        const alertMeWhenAvailableForm = document.querySelector(`[data-forms-id="forms-root-939827"]`);
                        const alertMeWhenAvailableFormRoot = alertMeWhenAvailableForm?.firstElementChild?.shadowRoot;
                        const alertMeWhenAvailableLink = document.getElementById(alertLinkId);
                        const emailField = alertMeWhenAvailableFormRoot?.getElementById('email');
                        const productHandleField = alertMeWhenAvailableFormRoot?.getElementById('custom#instocknotificationproducthandle');
                        if (productHandleField && emailField && customerEmail && alertMeWhenAvailableLink) {
                          this.bindBackInStockAlertLink(alertLinkId);
                        }
                      })
                      .catch(() => {})
                      .finally(() => finalizeNoListingsState());
                  } else {
                    finalizeNoListingsState();
                  }
                  return;
                }

                let firstAvailableVariantOption = document.getElementById("firstAvailableVariantOption");
                if (firstAvailableVariantOption) {
                  firstAvailableVariantOption = firstAvailableVariantOption.innerText.trim();
                }
                let firstAvailableVariantId = document.getElementById("firstAvailableVariantId");
                if (firstAvailableVariantId) {
                  firstAvailableVariantId = firstAvailableVariantId.innerText.trim();
                }

                const setCompletenessOptionHeadings = document.evaluate("//label[@class='form__label' and contains(., 'Set Completeness')]", document, null, XPathResult.ANY_TYPE, null).iterateNext();
                let defaultVariant = "";
                if (setCompletenessOptionHeadings) {
                  if (productDescription.includes("New in Box/Sprue") || (productDescription.includes("New in Box") && productTags &&
                   (productTags.innerText.includes('Warhammer') || productTags.innerText.includes('Age of Sigmar') || productTags.innerText.includes('Blood Bowl')))) {
                    defaultVariant = "New in Box (Complete)";
                  } else {
                    defaultVariant = "Complete";
                  }
                } else if (document.evaluate("//label[@class='form__label' and contains(., 'Title')]", document, null, XPathResult.ANY_TYPE, null).iterateNext()) {
                    defaultVariant = "Default Title";
                } else {
                    defaultVariant = "Near Mint";
                }

                // If on page load, there are no Near Mint, New in Box, or Complete listings as is the default, but there are other listings, redirect to the first available condition
                if (availableCountryForVariants[country].length > 0 && availableCountryForVariants[country].filter(variant => variant.split(" / ").includes(defaultVariant) && availableCountryForVariants[country].includes(variant)).length === 0 && !window.location.href.includes("variant=")) {
                  if (firstAvailableVariantOption && firstAvailableVariantId && currentVariantId !== firstAvailableVariantId && firstAvailableVariantOption !== "Complete / Near Mint" && firstAvailableVariantOption !== "New in Box (Complete) / Near Mint" && firstAvailableVariantOption !== "Near Mint" && firstAvailableVariantOption !== "Default Title")  {
                    let baseUrl = window.location.href;
                    if (baseUrl.includes("?variant=")) {
                      baseUrl = baseUrl.replace(/\?variant=\d+&?/g, '');
                    }
                    const parameterDelimeter = baseUrl.includes("?") ? "&" : "?";
                    window.location.href = `${baseUrl}${parameterDelimeter}variant=${firstAvailableVariantId}`;
                    return;
                  } else {
                    const setCompletenessVariantToClick = document.querySelectorAll(`div.select option[value="${availableCountryForVariants[country][0].split(" / ")[0]}"]`)[0];
                    if (setCompletenessVariantToClick && !setCompletenessVariantToClick.selected) {
                      setCompletenessVariantToClick.setAttribute("selected", "selected");
                      setCompletenessVariantToClick.parentElement.dispatchEvent(new Event('change', {'view': window,'bubbles': true}));
                      return;
                    }
                  }
                }

                let currentSetCompletenessVariant;
                if (setCompletenessOptionHeadings) {
                  currentSetCompletenessVariant = [...setCompletenessOptionHeadings.parentElement.querySelectorAll('div.select option:checked')][0].value;
                  const conditionOptionHeadings = document.evaluate("//label[@class='form__label' and contains(., 'Condition')]", document, null, XPathResult.ANY_TYPE, null).iterateNext();
                  const currentConditionVariant = [...conditionOptionHeadings.parentElement.querySelectorAll('div.select option:checked')][0].value;
                  if (availableCountryForVariants[country].filter(variant => variant === `${currentSetCompletenessVariant} / ${currentConditionVariant}` && availableCountryForVariants[country].includes(variant)).length === 0 && available_variants_array.filter(variant => variant.includes(currentSetCompletenessVariant)).length > 0) {
                      const conditionVariantToClick = document.querySelectorAll(`div.select option[value="${availableCountryForVariants[country].filter(variant => variant.includes(currentSetCompletenessVariant))[0].split(" / ")[1]}"]`)[0];
                      conditionVariantToClick.setAttribute("selected", "selected");
                      conditionVariantToClick.parentElement.dispatchEvent(new Event('change', {'view': window,'bubbles': true}));
                      return;
                  }
                }

                if (!setCompletenessOptionHeadings) {
                  const currentSingleVariant = [...document.querySelectorAll('div.select option:checked')].map(variant => variant.value).join(" / ");
                  const firstAvailableSingleVariant = availableCountryForVariants[country][0];
                  if (
                    currentSingleVariant &&
                    currentSingleVariant !== "Default Title" &&
                    firstAvailableSingleVariant &&
                    !availableCountryForVariants[country].includes(currentSingleVariant)
                  ) {
                    const singleVariantToClick = document.querySelectorAll(`div.select option[value="${firstAvailableSingleVariant}"]`)[0];
                    if (singleVariantToClick) {
                      singleVariantToClick.setAttribute("selected", "selected");
                      singleVariantToClick.parentElement.dispatchEvent(new Event('change', {'view': window,'bubbles': true}));
                      return;
                    }
                  }
                }

                [...variants].forEach(variant => {
                   if (availableCountryForVariants[country].filter(availableVariant => (availableVariant.includes(variant.value) && (!setCompletenessOptionHeadings || variant.parentElement.parentElement.parentElement.firstElementChild.innerText.trim() === "Set Completeness" || availableVariant.includes(currentSetCompletenessVariant))) && availableCountryForVariants[country].includes(availableVariant)).length === 0) {
                     variant.classList.add("disabled");
                      variant.setAttribute('style', 'cursor:default !important');
                   } else {
                     variant.classList.remove("disabled");
                     variant.setAttribute('style', 'cursor:pointer !important');
                   }
                });
                [...variants].forEach(variant => {
                  if (variant.classList.contains("disabled")) {
                    variant.remove();
                  } else {
                    variant.innerText = variant.innerText.replace(" - Unavailable", "");
                  }
                });
                const revealProductInfo = () => {
                  if (loadingSpinner) {
                    loadingSpinner.parentElement.style.textAlign = 'left';
                    loadingSpinner.classList.add('hidden');
                  }
                  globalContentLoadingDiv?.classList.remove('hidden');
                };
                Promise.all([this.waitForElement('table'), cartDataPromise])
                  .then(([, responseJson]) => this.processSellerDiv(available_variants, totalCardQuantityDataList, sellerProductCards, loadingSpinner, globalContentLoadingDiv, country, currentVariantId, responseJson, lotOnlyAvailabilityUrl))
                  .catch((error) => {
                    console.error('Error loading seller listings:', error);
                    revealProductInfo();
                  });
          });
        }).catch((error) => {
            console.error('Error:', error);
            if (loadingSpinner) {
              loadingSpinner.parentElement.style.textAlign = 'left';
              loadingSpinner.classList.add('hidden');
            }
            globalContentLoadingDiv?.classList.remove('hidden');
        });
      }

      waitForElement = (selector) => {
          return new Promise(resolve => {
              // 1. Check if the element already exists
              const existingEl = document.querySelector(selector);
              if (existingEl) return resolve(existingEl);

              // 2. Observe changes to the DOM
              const observer = new MutationObserver(() => {
                  const el = document.querySelector(selector);
                  if (el) {
                      observer.disconnect(); // Stop watching once found
                      resolve(el);
                  }
              });

              // Start observing the body for added children
              observer.observe(document.body, {
                  childList: true,
                  subtree: true
              });
          });
      }

      // Markup shared by the back-in-stock and price alert links. The bell and info tooltip come from the <template>s
      // main-product.liquid renders from snippets/alert-link-icon.liquid and snippets/alert-link-info.liquid.
      getAlertLinkHtml = (id, href, label, ariaLabel, modifier = '') => {
        const icon = document.getElementById('alertLinkIconTemplate')?.innerHTML.trim() || '';
        return `<a class="wk-alert-link ${modifier}" href="${href}" id="${id}" aria-label="${ariaLabel}">${icon}${label}</a>`;
      }

      // Info button + tooltip after an alert link; taps are handled at the top of this file.
      getAlertInfoHtml = (templateId) => document.getElementById(templateId)?.innerHTML.trim() || '';

      // Shared by the back-in-stock and price alert links, which both submit the hidden Shopify Form 939827.
      // Fields are looked up at submit time, as the form embed can finish rendering after a link is added.
      submitAlertForm = (fieldId, value) => {
        const formRoot = document.querySelector(`[data-forms-id="forms-root-939827"]`)?.firstElementChild?.shadowRoot;
        const customerEmail = document.getElementById('customerEmail')?.innerText || '';
        const emailField = formRoot?.getElementById('email');
        const alertField = formRoot?.getElementById(fieldId);
        const submitButton = alertField?.parentElement?.parentElement?.lastElementChild;
        if (!customerEmail || !emailField || !alertField || !submitButton) {
          return false;
        }

        emailField.value = customerEmail;
        alertField.value = value;
        [alertField, emailField].forEach((field) => {
          field.dispatchEvent(new Event('input', { bubbles: true }));
          field.dispatchEvent(new Event('change', { bubbles: true }));
        });
        submitButton.click();
        return true;
      }

      // Binds a click handler once per link. onSubmitted / onFailed receive the link.
      bindAlertLink = (link, fieldId, value, onSubmitted, onFailed = () => {}) => {
        if (!link || link.dataset.alertBindingAttached === 'true') {
          return;
        }

        link.dataset.alertBindingAttached = 'true';
        link.addEventListener('click', (event) => {
          event.preventDefault();
          if (this.submitAlertForm(fieldId, value)) {
            onSubmitted(link);
          } else {
            onFailed(link);
          }
        });
      }

      // Back-in-stock link in the "No Listings Available" heading, already rendered by the no-listings state.
      bindBackInStockAlertLink = (alertLinkId) => {
        const productHandle = document.getElementById('productHandle')?.innerText.trim() || '';
        const isRemove = alertLinkId === 'removeBackInStockAlert';
        if (!productHandle) {
          return;
        }

        this.bindAlertLink(
          document.getElementById(alertLinkId),
          isRemove ? 'custom#instocknotificationalertremove' : 'custom#instocknotificationproducthandle',
          productHandle,
          (link) => {
            const panel = link.closest('.wk-stock-alert');
            if (!panel) return;
            const title = document.createElement('h3');
            title.className = 'wk-stock-alert__title';
            title.textContent = isRemove ? 'Alert removed' : 'Alert created';
            const message = document.createElement('p');
            message.className = 'wk-stock-alert__copy';
            message.textContent = isRemove
              ? 'You will no longer receive an email when a seller lists this item.'
              : 'We’ll email you when a seller lists this item.';
            const note = document.createElement('p');
            note.className = 'wk-stock-alert__note';
            note.textContent = 'It may take a few minutes for this page to update.';
            panel.classList.add('wk-stock-alert--success');
            panel.setAttribute('role', 'status');
            panel.replaceChildren(title, message, note);
          }
        );
      }

      // Price alert link in the listings header, already rendered by refreshListingsSummary.
      bindPriceAlertLink = (alertLinkId, country) => {
        const productHandle = document.getElementById('productHandle')?.innerText.trim() || '';
        const marketKey = document.getElementById('priceAlertMarket')?.innerText.trim() || '';
        const isRemove = alertLinkId === 'removePriceAlert';
        if (!productHandle || !marketKey) {
          return;
        }

        this.bindAlertLink(
          document.getElementById(alertLinkId),
          isRemove ? 'custom#pricealertremove' : 'custom#pricealertproducthandle',
          `${productHandle}_${marketKey}`,
          (link) => {
            const priceAlertWrapper = link.parentElement;
            priceAlertWrapper.innerText = isRemove
              ? 'Price alert removed. It may take a few minutes to reflect on this page.'
              : `Price alert created. You will receive an email when a listing is priced at or below the current lowest price for its condition. It may take a few minutes to reflect on this page.`;
            priceAlertWrapper.classList.add('wk-alert-status');
            priceAlertWrapper.setAttribute('role', 'status');
          },
          (link) => {
            const wrapper = link.parentElement;
            wrapper.innerText = 'Unable to update the price alert. Please refresh the page and try again.';
            wrapper.classList.add('wk-alert-status', 'wk-alert-status--error');
            wrapper.setAttribute('role', 'alert');
          }
        );
      }

      // Read numeric price from the card, ignoring the Free Shipping pill text in the same column.
      getSellerRowPrice = (sellerRow) => {
        const priceBlock = sellerRow.querySelector('.wk-seller-card__price');
        if (priceBlock) {
          const priceNode =
            priceBlock.querySelector(':scope > :not(.wk-seller-card__shipping)') ||
            priceBlock.firstElementChild;
          if (priceNode && !priceNode.classList.contains('wk-seller-card__shipping')) {
            const parsed = parseListingPrice(priceNode.innerText);
            if (parsed !== null) {
              return parsed;
            }
          }
        }
        const fallbackText = sellerRow.cells[sellerRow.cells.length - 2]?.innerText || '';
        return parseListingPrice(fallbackText);
      };

      clearSellerRowFeatured = (sellerRow) => {
        sellerRow.classList.remove('wk-seller-row--featured');
        const card = sellerRow.querySelector('.wk-seller-card');
        if (card) {
          card.classList.remove('wk-seller-card--best-value');
        }
        sellerRow.querySelector('.wk-seller-badge--best-value')?.remove();
      };

      applySellerRowFeatured = (sellerRow) => {
        sellerRow.classList.add('wk-seller-row--featured');
        const card = sellerRow.querySelector('.wk-seller-card');
        if (card) {
          card.classList.add('wk-seller-card--best-value');
        }
        const colInfo = sellerRow.querySelector('.wk-seller-card__col-info');
        const badgeHost = colInfo?.querySelector('.wk-seller-card__info-header') || colInfo;
        if (badgeHost && !colInfo.querySelector('.wk-seller-badge--best-value')) {
          const badge = document.createElement('span');
          badge.classList.add('wk-seller-badge--best-value');
          badge.innerHTML = `<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg><span>Best value</span>`;
          badgeHost.insertBefore(badge, badgeHost.firstChild);
        }
      };

      // After all seller rows are built, feature the cheapest listing (not first in DOM order).
      promoteLowestPriceListing = (table) => {
        const tbody = table.tBodies[0] || table;
        const sellerRows = [...table.querySelectorAll('tr.wk-seller-row')];
        if (sellerRows.length === 0) {
          return;
        }

        sellerRows.forEach((row) => this.clearSellerRowFeatured(row));

        let lowestRow = sellerRows[0];
        let lowestPrice = this.getSellerRowPrice(lowestRow);

        sellerRows.forEach((row) => {
          const price = this.getSellerRowPrice(row);
          if (price === null) {
            return;
          }
          if (lowestPrice === null || price < lowestPrice) {
            lowestPrice = price;
            lowestRow = row;
          }
        });

        if (lowestPrice === null) {
          return;
        }

        const firstSellerRow = tbody.querySelector('tr.wk-seller-row');
        if (firstSellerRow && lowestRow !== firstSellerRow) {
          tbody.insertBefore(lowestRow, firstSellerRow);
        }

        this.applySellerRowFeatured(lowestRow);
      };

      // Inject/update "X Listings", "As low as", guarantee banner, and hide legacy table chrome.
      refreshListingsSummary = (table, currentVariant) => {
        const sellerRows = [...table.querySelectorAll('tr.wk-seller-row')];
        const priceArray = sellerRows
          .map((row) => this.getSellerRowPrice(row))
          .filter((price) => price !== null);

        let average = 'N/A';
        let median = 'N/A';
        let lowest = 'N/A';
        const visibleCount = sellerRows.length;

        if (priceArray.length > 0) {
          const sortedPrices = [...priceArray].sort((a, b) => a - b);
          lowest = '$' + Math.min(...priceArray).toFixed(2);
          const half = Math.floor(sortedPrices.length / 2);
          median =
            '$' +
            (sortedPrices.length % 2
              ? sortedPrices[half]
              : (sortedPrices[half - 1] + sortedPrices[half]) / 2
            ).toFixed(2);
          average =
            '$' + ((priceArray.reduce((sum, price) => sum + price, 0) / priceArray.length) + Number.EPSILON).toFixed(2);
        }

        const wk_global_div = document.getElementsByClassName('wk_global_product')[0];
        if (!wk_global_div) {
          return;
        }

        const lastSoldListingPrice = readLastSoldListingPrice();
        let aggregateListingDataDiv = document.getElementById('aggregateListingDataDiv');

        if (!aggregateListingDataDiv) {
          aggregateListingDataDiv = document.createElement('div');
          aggregateListingDataDiv.id = 'aggregateListingDataDiv';
          aggregateListingDataDiv.classList.add('aggregateListingDataDiv-flex-row');
          aggregateListingDataDiv.innerHTML = buildMarketStatsHtml({
            average,
            median,
            lastSoldListingPrice,
          });
          wk_global_div.prepend(aggregateListingDataDiv);

          const sellProduct = document.getElementById('sellProduct');
          if (sellProduct) {
            const sellProductLinkClone = sellProduct.cloneNode(true);
            sellProductLinkClone.style.display = 'block';
            wk_global_div.prepend(sellProductLinkClone);
            sellProduct.remove();
          }

          if (currentVariant && currentVariant !== 'Default Title') {
            const currentVariantText = document.createElement('p');
            currentVariantText.innerHTML = '<b>' + currentVariant + '</b>';
            wk_global_div.prepend(currentVariantText);
          }
        } else {
          const averageEl = document.getElementById('averagePrice');
          const medianEl = document.getElementById('medianPrice');
          if (averageEl) averageEl.textContent = average;
          if (medianEl) medianEl.textContent = median;
        }

        let listingsHeaderDiv = document.getElementById('listingsHeader');

        if (!listingsHeaderDiv) {
          listingsHeaderDiv = document.createElement('div');
          listingsHeaderDiv.id = 'listingsHeader';
          listingsHeaderDiv.classList.add('wk-listings-header');

          const listingsCountElement = document.createElement('h2');
          listingsCountElement.classList.add('wk-listings-header__count');

          const listingsLowestElement = document.createElement('p');
          listingsLowestElement.classList.add('wk-listings-header__lowest');

          const guaranteeWrapper = document.createElement('div');
          guaranteeWrapper.classList.add('wk-listings-header__guarantee');

          const guaranteeText = document.createElement('p');
          guaranteeText.classList.add('wk-listings-header__guarantee-text');
          guaranteeText.innerHTML = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6D28D9" stroke-width="2.5" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg><span class="wk-listings-header__guarantee-copy">All purchases are protected by our Buyer Protection Guarantee. <a class="wk-listings-header__guarantee-link" href="/policies/refund-policy" title="Wargame Trader Refund Policy" target="_blank" rel="noopener noreferrer">Learn more</a></span>`;

          guaranteeWrapper.append(guaranteeText);

          const listingsSubRow = document.createElement('div');
          listingsSubRow.classList.add('wk-listings-header__subrow');
          listingsSubRow.appendChild(listingsLowestElement);
          listingsHeaderDiv.appendChild(listingsCountElement);
          listingsHeaderDiv.appendChild(listingsSubRow);

          const priceAlertMarket = document.getElementById('priceAlertMarket')?.innerText.trim() || '';
          if (priceAlertMarket) {
            const customerEmail = document.getElementById('customerEmail')?.innerText || '';
            const hasPriceAlert = Boolean(document.getElementById('priceAlertExists')?.innerText.trim());
            const priceAlertHref = customerEmail.length > 0 ? '#' : `/customer_authentication/login?return_to=${window.location.pathname}`;
            const priceAlertWrapper = document.createElement('p');
            priceAlertWrapper.id = 'priceAlertLinkWrapper';
            priceAlertWrapper.classList.add('wk-alert-link-row');
            priceAlertWrapper.innerHTML = (hasPriceAlert ? this.getAlertLinkHtml('removePriceAlert', '#', 'Remove Alert', 'Remove lower price alert') : this.getAlertLinkHtml('priceAlert', priceAlertHref, 'Get alerts', 'Alert me when a lower price is listed'));
            listingsHeaderDiv.appendChild(priceAlertWrapper);
          }

          listingsHeaderDiv.appendChild(guaranteeWrapper);

          const aggregateEl = document.getElementById('aggregateListingDataDiv');
          if (aggregateEl) {
            aggregateEl.insertAdjacentElement('afterend', listingsHeaderDiv);
          } else {
            wk_global_div.prepend(listingsHeaderDiv);
          }
        }

        listingsHeaderDiv.querySelector('.wk-listings-header__count').innerText =
          `${visibleCount} ${visibleCount === 1 ? 'Listing' : 'Listings'}`;
        listingsHeaderDiv.querySelector('.wk-listings-header__lowest').innerText = `As low as ${lowest}`;

        const soldByHeading = listingsHeaderDiv.nextElementSibling;
        if (soldByHeading?.matches('h2') && /^Sold By:?$/i.test(soldByHeading.textContent.trim())) {
          soldByHeading.remove();
        }

        table.classList.add('wk-seller-listings-table');
        this.ensureListingsSectionWrapper();
      };

      ensureListingsSectionWrapper = () => {
        const wkGlobalDiv = document.querySelector('.wk_global_product');
        const variantSelects = document.querySelector('variant-selects[id^="variant-selects-template--"]');
        if (!wkGlobalDiv || !variantSelects || document.getElementById('wkListingsSection')) {
          return;
        }

        const wrapper = document.createElement('div');
        wrapper.id = 'wkListingsSection';
        wrapper.classList.add('wk-listings-section');
        wkGlobalDiv.parentNode.insertBefore(wrapper, wkGlobalDiv);
        wrapper.appendChild(wkGlobalDiv);

        const productTax = this.querySelector('.product__tax');
        if (productTax) {
          wrapper.appendChild(productTax);
        }

        wrapper.appendChild(variantSelects);
      };

      processSellerDiv = (available_variants, totalCardQuantityDataList, sellerProductCards, loadingSpinner, globalContentLoadingDiv, country, currentVariantId, responseJson, lotOnlyAvailabilityUrl = '') => {
        // Hide the recommended products div if there are no products to display.
        const recommendedProducts = [...document.getElementsByClassName("related-products")][0];
        if (recommendedProducts && recommendedProducts.lastElementChild && recommendedProducts.lastElementChild.innerText === "") {
          recommendedProducts.remove();
        }
        // Get each variant that's in stock for this product
        [...sellerProductCards.getElementsByClassName('card__information')].forEach(card => {
                if (isLotSellerListingCard(card)) {
                  return;
                }
                const cardQuantity = card.parentElement.id;
                let variantUrl;
                if (card.firstElementChild && card.firstElementChild.firstElementChild) {
                  variantUrl = card.firstElementChild.firstElementChild.href;
                }
                if (!totalCardQuantityDataList.includes(cardQuantity)) {
                  totalCardQuantityDataList.push(cardQuantity);
                  let cardQuantityDataList = cardQuantity.split("+++");
                  cardQuantityDataList = cardQuantityDataList.filter(data => data !== "");
                  [...cardQuantityDataList].forEach(cardQuantityData => {
                    cardQuantityData = cardQuantityData.split("---");
                    if (cardQuantityData.length > 0) {
                      this.addSellerQuantities(cardQuantityData, responseJson.items, variantUrl, country, currentVariantId);
                    }
                  });
                }
              });
              const currentVariant = [...document.querySelectorAll('div.select option:checked')]
                .map((variant) => variant.value)
                .join(' / ');
              let table = document.getElementsByTagName("table");
              if (table.length > 0) {
                // Cleanup unprocessed seller rows, for example, ones where the country does not match the current market.
                table = table[0];
                [...table.rows].forEach(sellerRow => {
                  if (!sellerRow.classList.contains("row-modifications-processed")) {
                    sellerRow.remove();
                  }
                });
                this.promoteLowestPriceListing(table);
                this.refreshListingsSummary(table, currentVariant);
                if (table.rows.length === 0) {
                  // If there's no available variants after filtering out invalid variants, set each one to unavailable., hide the div, then return
                  const emptyListingsMessage = lotOnlyAvailabilityUrl
                    ? buildLotOnlyAvailabilityHtml(lotOnlyAvailabilityUrl)
                    : 'No Listings Available';
                  document.querySelector('variant-selects[id^="variant-selects-template--"]').innerHTML = `<h3>${emptyListingsMessage}</h3>`;
                  const wkGlobalDiv = document.getElementsByClassName('wk_global_product')[0];
                  if (wkGlobalDiv) {
                    wkGlobalDiv.remove();
                  }
                  if (loadingSpinner) {
                    loadingSpinner.parentElement.style.textAlign = 'left';
                    loadingSpinner.classList.add('hidden');
                  }
                  globalContentLoadingDiv.classList.remove('hidden');
                  return;
                }
              }
              if (currentVariant && currentVariant == "Default Title") {
                document.querySelector('variant-selects[id^="variant-selects-template--"]').style.display = 'none';
              }
              this.processSellerItems(responseJson);
              const priceAlertLink = document.getElementById('priceAlert') || document.getElementById('removePriceAlert');
              if (priceAlertLink && document.getElementById('customerEmail')?.innerText) {
                this.bindPriceAlertLink(priceAlertLink.id, country);
              }

              if (loadingSpinner) {
                loadingSpinner.parentElement.style.textAlign = 'left';
                loadingSpinner.classList.add('hidden');
              }
        globalContentLoadingDiv.classList.remove('hidden');
        }

      syncAddToCartButtonState = (button, input, setButtonDisabled = false) => {
        if (!button || !input) return;
        const quantity = parseInt(input.value, 10);
        const available = parseInt(button.dataset.quantityAvailable, 10);
        const inCart = parseInt(button.dataset.totalCartQuantity, 10);
        const canAdd =
          !setButtonDisabled &&
          quantity > 0 &&
          !Number.isNaN(available) &&
          !Number.isNaN(inCart) &&
          available !== inCart;

        button.disabled = !canAdd;
      };

      processSellerItems = (responseJson) => {
        const buyNowButtons = document.getElementsByClassName('wk_atc');
        [...buyNowButtons].forEach((button) => {
          const main_variant_id = button.dataset.vid;
          button.setAttribute('title', '');
          button.disabled = true;
          button.classList.add('addToCartButton');

          const filteredItems = responseJson.items.filter((item) => item.id === parseInt(main_variant_id, 10));
          let setButtonDisabled = false;
          if (
            filteredItems.length > 0 &&
            parseInt(button.dataset.quantityAvailable, 10) === parseInt(button.dataset.totalCartQuantity, 10)
          ) {
            button.setAttribute('title', 'You already have the maximum number of this item in your cart.');
            setButtonDisabled = true;
            button.addEventListener('onmousedown', this.maxItemsInCart);
            button.removeEventListener('click', this.addToCart);
          } else {
            button.innerText = 'Add to Cart';
            button.addEventListener('click', this.addToCart);
          }

          const sellerCard = button.closest('.wk-seller-card');
          const input =
            sellerCard?.querySelector('.wk-seller-quantity-input') ||
            (main_variant_id ? document.getElementsByClassName(main_variant_id)[0] : null);

          if (input) {
            this.syncAddToCartButtonState(button, input, setButtonDisabled);
            input.addEventListener('input', (e) => {
              const quantityInput = e.target;
              const relatedButton =
                quantityInput.closest('.wk-seller-card')?.querySelector('.wk_atc') ||
                Array.from(document.querySelectorAll(`button[data-vid="${quantityInput.classList[0]}"]`))[0];
              if (!relatedButton) return;
              this.syncAddToCartButtonState(relatedButton, quantityInput, setButtonDisabled);
            });
          }
        });
      };

      addSellerQuantities = (sellerData, cartItems, variantUrl, country, currentVariantId) => {
        let table = document.getElementsByTagName("table");
        if (table.length > 0) {
          table = table[0];
          table.classList.add('wk-seller-listings-table');
          const emptyTableHead = table.querySelector('thead');
          if (emptyTableHead && emptyTableHead.children.length === 0 && emptyTableHead.textContent.trim() === '') {
            emptyTableHead.remove();
          }
          const rows = table.rows;
          const currentVariant = [...document.querySelectorAll('div.select option:checked')].map(variant => variant.value).join(" / ");
          const sellerDataVariant = sellerData[0];
          const sellerDataName = sellerData[1];
          const sellerDataPrice = sellerData[2].replace(/,/g, "");
          const sellerDataQuantity = sellerData[3];
          const sellerDataQuantityInt = parseInt(sellerDataQuantity);
          const variantCountry = sellerData[4];

          [...rows].forEach(sellerRow => {
            if (sellerRow.classList.contains("row-modifications-processed") || sellerRow.cells.length < 2) {
              return;
            }
            const sellerName = sellerRow.cells[0].innerText;
            const sellerPrice = sellerRow.cells[sellerRow.cells.length - 2].innerText;
            const rowData = [currentVariant, sellerName, sellerPrice];
            // Note: Disabling this code for now since we do not support international sales. NOTE: KEEPING AT USD FOR NOW. Canadian dollars aren't found in the webkul end, so ignore price comparision for multiple products of the same seller and variant at different prices for now.
            //const isCanadianCurrency = document.getElementsByName("country_code")[0].value === "CA";
            //const isUKCurrency = document.getElementsByName("country_code")[0].value === "UK";

            if (
              sellerNamesMatch(sellerName, sellerDataName) &&
              sellerPricesMatch(sellerPrice, sellerDataPrice) &&
              sellerDataVariant === currentVariant &&
              sellerDataQuantityInt > 0
            ) {
                // Hide rows for other markets.
                if (country !== variantCountry) {
                  sellerRow.remove();
                  return;
                }
                if (!document.getElementById("QuantityHeader")) {
                  const newHeaderCol = document.createElement('th');
                  newHeaderCol.innerText = "Quantity";
                  newHeaderCol.id = "QuantityHeader";
                  let previousHeaderCol = table.querySelector('thead > tr:first-child');
                  if (previousHeaderCol) {
                      previousHeaderCol = previousHeaderCol.cells[2];
                      previousHeaderCol.parentNode.insertBefore(newHeaderCol, previousHeaderCol);
                  }
              }
              const buttonCell = sellerRow.cells[sellerRow.cells.length - 1];
              const button = buttonCell.firstChild;
              if (!button) {
                return;
              }
              let customDescription = sellerRow.querySelector('.caption');
              let customImage = sellerRow.querySelector('img');
              if (customDescription) {
                if (customDescription.innerText === "undefined" || customDescription.innerText === "-" || customDescription === null) {
                  customDescription.parentElement.remove();
                  customDescription = null;
                }
                if (customDescription) {
                  customDescription.classList.remove("caption");
                  customDescription.classList.add("wk-seller-description-text");
                  customDescription.parentElement.marginTop = '0px';
                  customDescription.parentElement.marginBottom = '0px';
                }
              }

              // This should not occur unless there's a bug during product listing, but check for it just in case.
              const viewAllSellersXpath = "//a[text()='View All Sellers']";
              const viewAllSellersResult = document.evaluate(viewAllSellersXpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);
              const viewAllSellersElement = viewAllSellersResult.singleNodeValue;

              if (viewAllSellersElement) {
                viewAllSellersElement.remove();
              }

              if (customImage) {
                const customImageCell = customImage.closest('td');
                if (customImage && (customImage.src === "https://www.wargametrader.com/products/undefined" || customImage.src === "https://www.wargametrader.com/products/null" || customImage.src === "https://sp-seller.webkul.com/img/No-Image/No-Image-190x190.png" || currentVariant === "New in Box (Complete) / Near Mint" || currentVariant === "Default Title")) {
                  customImageCell.remove();
                  customImage = null;
                } else {
                  const link = document.createElement('a');

                  link.href = (variantUrl.includes('variant=') || !currentVariantId) ? variantUrl : variantUrl.replace('?', `?variant=${currentVariantId}&`);
                  const productTitle = document.getElementsByClassName("product__title")[0].firstElementChild.innerText;
                  link.setAttribute("aria-label", `Link to Specific ${productTitle} Sold By ${sellerName} at ${sellerPrice}`);
                  customImage.classList.add('wk-seller-custom-image', 'wk-seller-custom-image--table');
                  customImage.alt = `Image of Specific ${productTitle} Sold By ${sellerName} at ${sellerPrice}`
                  const customImageClone = customImage.cloneNode(true);

                  const overlayDiv = document.createElement("DIV");
                  overlayDiv.classList.add('customImageOverlay', 'customImageOverlay--hidden');
                  overlayDiv.style.backgroundImage = `url(${customImageClone.src})`;

                  link.target = "_blank";
                  link.appendChild(customImageClone);
                  customImageClone.classList.add('wk-seller-custom-image', 'wk-seller-custom-image--table');

                  link.appendChild(overlayDiv);

                  customImageCell.firstElementChild.appendChild(link);
                  customImage.remove();

                  // Add zoom-in overlay on image mousemove
                  customImageClone.addEventListener("mousemove", this.customImageZoomIn);

                  // Hide zoom-in overlay on image mouseout
                  customImageClone.addEventListener("mouseout", function(event) {
                      const overlay = event.target.nextElementSibling;
                      overlay?.classList.add('customImageOverlay--hidden');
                  });
                }
              }
              if (button.dataset) {
                const filteredItems = cartItems.filter((item) => item.id === parseInt(button.dataset.vid));
                let totalCartQuantity = 0;
                filteredItems.forEach(item => {
                  totalCartQuantity += item.quantity;
                });
                 // If all items are in the cart, change to remove item and set the value to the max.
                const totalQuantityLeft = totalCartQuantity === sellerDataQuantityInt ? totalCartQuantity : sellerDataQuantityInt - totalCartQuantity;
                button.dataset.quantityAvailable = sellerDataQuantity;
                button.dataset.totalCartQuantity = totalCartQuantity;
                const quantityWrapperDiv = document.createElement("DIV");
                quantityWrapperDiv.classList.add("wk-seller-quantity");

                const stepperRow = document.createElement("div");
                stepperRow.classList.add("wk-seller-quantity__stepper");

                const minusBtn = document.createElement("button");
                minusBtn.type = "button";
                minusBtn.textContent = "−";
                minusBtn.classList.add("wk-seller-quantity__btn");

                const quantityInput = document.createElement("INPUT");
                quantityInput.setAttribute('aria-label', 'Quantity');
                quantityInput.name = "quantity";
                quantityInput.setAttribute("type", "number");
                quantityInput.setAttribute("max", totalQuantityLeft);
                quantityInput.setAttribute("min", 1);
                quantityInput.value =
                  totalCartQuantity === 0 ? 1 : Math.min(totalCartQuantity, totalQuantityLeft);
                quantityInput.classList.add(button.dataset.vid);
                quantityInput.classList.add("wk-seller-quantity-input");

                const plusBtn = document.createElement("button");
                plusBtn.type = "button";
                plusBtn.textContent = "+";
                plusBtn.classList.add("wk-seller-quantity__btn");

                stepperRow.appendChild(minusBtn);
                stepperRow.appendChild(quantityInput);
                stepperRow.appendChild(plusBtn);

                const quantityDescription = document.createElement("p");
                quantityDescription.innerText = `of ${sellerDataQuantity} available`;
                quantityDescription.classList.add("wk-seller-quantity-total");

                quantityWrapperDiv.appendChild(stepperRow);
                quantityWrapperDiv.appendChild(quantityDescription);
                buttonCell.insertBefore(quantityWrapperDiv, button);

                minusBtn.addEventListener("click", () => {
                  const v = parseInt(quantityInput.value);
                  if (v > 1) { quantityInput.value = v - 1; quantityInput.dispatchEvent(new Event('input')); }
                });
                plusBtn.addEventListener("click", () => {
                  const v = parseInt(quantityInput.value);
                  if (v < parseInt(quantityInput.max)) { quantityInput.value = v + 1; quantityInput.dispatchEvent(new Event('input')); }
                });
                quantityInput.addEventListener("input", function(event) {
                    let quantityInput = event.target;
                    let min = quantityInput.min;
                    let max = quantityInput.max;
                    let value = parseInt(quantityInput.value);
                    if (value > max) {
                        quantityInput.value = max;
                    } else if (value < min) {
                        quantityInput.value = min;
                    }
                });
              }
              this.applyCompactSellerRowLayout(sellerRow, customDescription, customImage);
              // Mark this row as successfully processed
              sellerRow.classList.add("row-modifications-processed");
            }
          });
        }
      }

      createSellerCardPriceBlock = (priceCell) => {
        const priceBlock = document.createElement('div');
        priceBlock.classList.add('wk-seller-card__price');

        while (priceCell.firstChild) {
          priceBlock.appendChild(priceCell.firstChild);
        }

        if (priceBlock.firstChild?.nodeType === Node.ELEMENT_NODE) {
          priceBlock.firstChild.classList.add('wk-seller-card__price-value');
        }

        const shippingPill = document.createElement('span');
        shippingPill.classList.add('wk-seller-card__shipping');
        shippingPill.innerHTML = `${SHIPPING_TRUCK_ICON_SVG}<span>Free Shipping</span>`;
        priceBlock.appendChild(shippingPill);

        return priceBlock;
      };

      createSellerCardQtyRow = (buttonCell) => {
        const quantityColumn = document.createElement('div');
        quantityColumn.classList.add('wk-seller-card__quantity-col');

        const quantityEl = buttonCell.querySelector('.wk-seller-quantity');
        if (quantityEl) {
          quantityColumn.appendChild(quantityEl);
        }

        const qtyLabel = document.createElement('p');
        qtyLabel.classList.add('wk-seller-card__qty-label');
        qtyLabel.textContent = 'Qty';

        const qtyRow = document.createElement('div');
        qtyRow.classList.add('wk-seller-card__qty-row');
        qtyRow.appendChild(qtyLabel);
        qtyRow.appendChild(quantityColumn);

        return qtyRow;
      };

      createSellerCardCartColumn = (buttonCell) => {
        const cartColumn = document.createElement('div');
        cartColumn.classList.add('wk-seller-card__cart-col');

        while (buttonCell.firstChild) {
          cartColumn.appendChild(buttonCell.firstChild);
        }

        return cartColumn;
      };

      collectSellerCardContent = (sellerRow, customDescription, customImage) => {
        const cells = [...sellerRow.cells];
        if (cells.length < 3) {
          return null;
        }

        const sellerCell = cells[0];
        const priceCell = cells[cells.length - 2];
        const buttonCell = cells[cells.length - 1];
        const descriptionCell = customDescription ? customDescription.closest('td') : null;
        const imageCell = customImage ? customImage.closest('td') : null;

        sellerRow.classList.add('wk-seller-row');

        const excludedCells = new Set([sellerCell, priceCell, buttonCell]);
        if (descriptionCell) excludedCells.add(descriptionCell);
        if (imageCell) excludedCells.add(imageCell);

        const metaCells = cells.filter((cell) => !excludedCells.has(cell));

        const sellerBlock = document.createElement('div');
        sellerBlock.classList.add('wk-seller-card__seller');
        while (sellerCell.firstChild) {
          sellerBlock.appendChild(sellerCell.firstChild);
        }

        const sellerLink = sellerBlock.querySelector('a');
        if (sellerLink) {
          sellerLink.classList.add('wk-seller-card__seller-link');
        }

        const metaBlock = document.createElement('div');
        metaBlock.classList.add('wk-seller-card__meta');
        metaCells.forEach((metaCell) => {
          while (metaCell.firstChild) {
            metaBlock.appendChild(metaCell.firstChild);
          }
          metaCell.remove();
        });

        const descriptionBlock = document.createElement('div');
        descriptionBlock.classList.add('wk-seller-card__description');
        if (descriptionCell && descriptionCell !== sellerCell && descriptionCell !== priceCell && descriptionCell !== buttonCell) {
          while (descriptionCell.firstChild) {
            descriptionBlock.appendChild(descriptionCell.firstChild);
          }
          descriptionCell.remove();
        }

        const imageBlock = document.createElement('div');
        imageBlock.classList.add('wk-seller-card__image');
        let hasImage = false;

        if (imageCell && imageCell !== sellerCell && imageCell !== priceCell && imageCell !== buttonCell) {
          while (imageCell.firstChild) {
            imageBlock.appendChild(imageCell.firstChild);
          }
          imageCell.remove();
          hasImage = true;
        }

        if (!hasImage) {
          const nestedImage = metaBlock.querySelector('img');
          if (nestedImage) {
            const nestedImageLink = nestedImage.closest('a');
            const nestedImageWrapper = nestedImage.closest('span, div, p');
            const nestedImageElement = nestedImageLink || nestedImageWrapper || nestedImage;
            imageBlock.appendChild(nestedImageElement);
            hasImage = true;
          }
        }

        if (metaBlock.textContent.trim() === '' && metaBlock.querySelectorAll('img').length === 0) {
          while (metaBlock.firstChild) {
            metaBlock.removeChild(metaBlock.firstChild);
          }
        }

        const priceBlock = this.createSellerCardPriceBlock(priceCell);
        const qtyRow = this.createSellerCardQtyRow(buttonCell);
        const cartColumn = this.createSellerCardCartColumn(buttonCell);

        return {
          buttonCell,
          cartColumn,
          cells,
          customImage,
          descriptionBlock,
          hasImage,
          hasMeta: metaBlock.childNodes.length > 0,
          hasDescription: descriptionBlock.childNodes.length > 0,
          imageBlock,
          metaBlock,
          priceBlock,
          priceCell,
          qtyRow,
          sellerBlock,
          sellerCell,
        };
      };

      mountSellerCard = (sellerCell, cells, card) => {
        sellerCell.innerHTML = '';
        sellerCell.classList.add('wk-seller-card-cell');
        sellerCell.colSpan = cells.length;
        sellerCell.appendChild(card);
      };

      // Desktop: image | info (badge, title, description) | actions (price, shipping, qty, ATC)
      // Mobile:  thumbnail + title header, description body, price/qty row, full-width ATC
      applySellerCardWithImageLayout = (content) => {
        const card = document.createElement('div');
        card.classList.add('wk-seller-card', 'wk-seller-card--has-image');
        if (content.customImage) {
          card.classList.add('wk-seller-card--custom-image');
        }
        if (content.hasMeta) {
          card.classList.add('wk-seller-card--has-meta');
        }
        if (content.hasDescription) {
          card.classList.add('wk-seller-card--has-description');
        }

        const colImage = document.createElement('div');
        colImage.classList.add('wk-seller-card__col-image');
        colImage.appendChild(content.imageBlock);

        const colInfo = document.createElement('div');
        colInfo.classList.add('wk-seller-card__col-info');

        const infoHeader = document.createElement('div');
        infoHeader.classList.add('wk-seller-card__info-header');
        infoHeader.appendChild(content.sellerBlock);
        colInfo.appendChild(infoHeader);

        if (content.hasMeta) {
          colInfo.appendChild(content.metaBlock);
        }
        if (content.hasDescription) {
          colInfo.appendChild(content.descriptionBlock);
        }

        const colActions = document.createElement('div');
        colActions.classList.add('wk-seller-card__col-actions');
        colActions.appendChild(content.priceBlock);
        colActions.appendChild(content.qtyRow);
        colActions.appendChild(content.cartColumn);

        card.appendChild(colImage);
        card.appendChild(colInfo);
        card.appendChild(colActions);

        this.mountSellerCard(content.sellerCell, content.cells, card);
        [content.priceCell, content.buttonCell].forEach((cell) => cell.remove());
      };

      // Desktop: info (badge, title) | pricing | qty | ATC — no description
      // Mobile:  badge/title, price/qty row, full-width ATC
      applySellerCardNoImageLayout = (content) => {
        const card = document.createElement('div');
        card.classList.add('wk-seller-card', 'wk-seller-card--no-image');
        if (content.hasMeta) {
          card.classList.add('wk-seller-card--has-meta');
        }

        const colInfo = document.createElement('div');
        colInfo.classList.add('wk-seller-card__col-info');

        const infoHeader = document.createElement('div');
        infoHeader.classList.add('wk-seller-card__info-header');
        infoHeader.appendChild(content.sellerBlock);
        colInfo.appendChild(infoHeader);

        if (content.hasMeta) {
          colInfo.appendChild(content.metaBlock);
        }

        const colPricing = document.createElement('div');
        colPricing.classList.add('wk-seller-card__col-pricing');
        colPricing.appendChild(content.priceBlock);

        const colQty = document.createElement('div');
        colQty.classList.add('wk-seller-card__col-qty');
        colQty.appendChild(content.qtyRow);

        const colCart = document.createElement('div');
        colCart.classList.add('wk-seller-card__col-cart');
        colCart.appendChild(content.cartColumn);

        card.appendChild(colInfo);
        card.appendChild(colPricing);
        card.appendChild(colQty);
        card.appendChild(colCart);

        this.mountSellerCard(content.sellerCell, content.cells, card);
        [content.priceCell, content.buttonCell].forEach((cell) => cell.remove());
      };

      // Collapse Webkul table cells into one card with image/no-image layout variants.
      applyCompactSellerRowLayout = (sellerRow, customDescription, customImage) => {
        const content = this.collectSellerCardContent(sellerRow, customDescription, customImage);
        if (!content) {
          return;
        }

        if (content.hasImage) {
          this.applySellerCardWithImageLayout(content);
        } else {
          this.applySellerCardNoImageLayout(content);
        }
      };

      customImageZoomIn = (event) => {
        const overlay = event.target.nextElementSibling;
        overlay?.classList.remove('customImageOverlay--hidden');
        const img = event.target;
        const posX = event.offsetX ? (event.offsetX) : event.pageX - img.offsetLeft;
        const posY = event.offsetY ? (event.offsetY) : event.pageY - img.offsetTop;
        overlay.style.backgroundPosition = (posX/overlay.offsetWidth*100) + "%" + (posY/overlay.offsetHeight*100) + "%";
        overlay.style.backgroundSize = '102%';
      }

      getCartUpdateTarget = () => {
        const cartTarget = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        return cartTarget && typeof cartTarget.renderContents === 'function' ? cartTarget : null;
      };

      updateSellerCartState = (button, quantityAdded) => {
        const input =
          button.closest('.wk-seller-card')?.querySelector('.wk-seller-quantity-input') ||
          document.getElementsByClassName(button.dataset.vid)[0];
        const previousCartQuantity = parseInt(button.dataset.totalCartQuantity, 10) || 0;
        const availableQuantity = parseInt(button.dataset.quantityAvailable, 10) || 0;
        const newCartQuantity = previousCartQuantity + quantityAdded;
        const quantityLeft = Math.max(availableQuantity - newCartQuantity, 0);

        button.dataset.totalCartQuantity = String(newCartQuantity);

        if (input) {
          const maxQuantity = quantityLeft === 0 ? newCartQuantity : quantityLeft;
          input.max = String(maxQuantity);
          input.value = String(newCartQuantity > 0 ? Math.min(newCartQuantity, maxQuantity) : 1);
        }

        if (quantityLeft === 0) {
          button.setAttribute('title', 'You already have the maximum number of this item in your cart.');
          button.removeEventListener('click', this.addToCart);
        }

        this.syncAddToCartButtonState(button, input, quantityLeft === 0);
      };

      addToCart = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const button = event.target.closest('button');
        if (!button || button.disabled) return;

        const quantityInput =
          button.closest('.wk-seller-card')?.querySelector('.wk-seller-quantity-input') ||
          document.getElementsByClassName(button.dataset.vid)[0];
        const quantity = parseInt(quantityInput?.value, 10);
        if (!quantity || quantity < 1) return;

        const cartTarget = this.getCartUpdateTarget();
        const sections = cartTarget?.getSectionsToRender?.().map((section) => section.id) || [];
        const previousButtonText = button.innerText;

        button.disabled = true;
        button.innerText = 'Adding...';

        try {
          fetch('/cart/add.js', {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({
              id: button.dataset.vid,
              quantity,
              sections,
              sections_url: window.location.pathname,
            })
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                throw new Error(response.description || response.message || 'Unable to add item to cart.');
              }

              if (cartTarget && response.sections) {
                cartTarget.setActiveElement?.(button);
                cartTarget.renderContents(response);
              } else {
                window.location = window.routes.cart_url;
                return;
              }

              this.updateSellerCartState(button, quantity);
              button.innerText = 'Added';
              window.setTimeout(() => {
                if (!button.disabled) {
                  button.innerText = previousButtonText;
                }
              }, 1400);
            })
            .catch((error) => {
              button.innerText = previousButtonText;
              button.disabled = false;
              console.error(error);
              alert(error.message || 'Unable to add item to cart.');
            });
        } catch(error) {
            button.innerText = previousButtonText;
            button.disabled = false;
            console.error(error);
        }
      }

      maxItemsInCart = () => {
        alert("Desired quantity not available. You already have all of these in your cart.");
      }

      // === WARGAME TRADER SELLER MARKETPLACE END ===
    }
  );
}
